var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSv = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
  fill: "#0052b4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M228.582 261.936L256 214.447l27.418 47.489z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M291.616 277.616L256 295.425l-35.616-17.809v-23.744h71.232z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M289.579 216.485l-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z",
  fill: "#ffda44"
})));

export default SvgSv;